module.exports = __webpack_public_path__ + "static/responsive-web-8487989daf40e737b17b16e61bbc3490.png";